module.exports = __webpack_public_path__ + "images/init/member-group-068be0f661bf7c8b31062b670f4cf700.png";